@if (dialogData.icon; as icon) { <mat-icon>{{ icon }}</mat-icon> }

<h2 mat-dialog-title>{{ dialogData.headline }}</h2>

<mat-dialog-content>
  <p [innerHTML]="dialogData.supportingText"></p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{ 'COMMON.ACTIONS.CANCEL' | translate }}</button>
  <button cdkFocusInitial mat-flat-button [mat-dialog-close]="true">{{ dialogData.confirmationButtonLabel }}</button>
</mat-dialog-actions>
